export enum ModalType {
  video = 1
}
